/**
 * Insertar item en LocalStorage
 * @param  {String} item  Key data a almacenar
 * @param  {String} data  Data a almacenar
 * @return {void}
 */
const setItem = (item, data) => window.localStorage.setItem(item, data)

/**
 * Consultar item en LocalStorage
 * @param  {String}   item  Key de la data a consultar
 * @return {String}   Data consultada
 */
const getItem = item => window.localStorage.getItem(item)

/**
 * Eliminar item de LocalStorage
 * @param  {String}   item  Key de la data a eliminar
 * @return {void}
 */
const removeItem = item => window.localStorage.removeItem(item)

const authLocalStorage = 'mexfon_web_auth'

export { setItem, getItem, removeItem, authLocalStorage }
